module.exports = __webpack_public_path__ + "static/ocean.92d04f9b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ocean.jpeg
// module id = 450
// module chunks = 168707334958949